import { render } from "./CommonExamView.vue?vue&type=template&id=678deab5&scoped=true"
import script from "./CommonExamView.vue?vue&type=script&lang=js"
export * from "./CommonExamView.vue?vue&type=script&lang=js"

import "./CommonExamView.vue?vue&type=style&index=0&id=678deab5&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678deab5"]])

export default __exports__